import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { NavbarComponent } from './shared/navbar/navbar.component';
import { NotificationsComponent } from './shared/notifications/notifications-modal/notifications.component';
import { AccountService } from './services/account.service';
import { FilterService } from './services/filter.service';
import { RequiredNotificationsService } from './shared/notifications/notifications.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [NavbarComponent, NotificationsComponent, RouterOutlet, CommonModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class AppComponent implements OnInit {
  accountService = inject(AccountService);
  filterService = inject(FilterService);
  requiredNotificationsService = inject(RequiredNotificationsService);

  ngOnInit(): void {
    this.accountService.getUser();
  }
}